export default __webpack_public_path__ + "static/30-techwear-b29a6f3ad10b7b8af792475191547ee5.png";